import type { Middleware } from '@reduxjs/toolkit'

import type { AppDispatch, RootState } from '~publish/legacy/store'
import { isLegacyAction } from '~publish/legacy/store/isAction'

const middleware: Middleware<object, RootState, AppDispatch> =
  ({ dispatch }) =>
  (next) =>
  (action): void => {
    next(action)
    if (!isLegacyAction(action)) return
    switch (action.type) {
      case 'APP_INIT':
        dispatch({ type: 'INIT_MODALS' })
        dispatch({ type: 'INIT_USER' })
        dispatch({ type: 'INIT_PROFILES' })
        dispatch({ type: 'INIT_CHECK_BOOKMARKLET' })
        dispatch({ type: 'INIT_STRIPE_DETAILS' })
        dispatch({ type: 'INIT_ORGANIZATIONS' })
        break
      default:
        break
    }
  }

export default middleware
